export default "__VITE_ASSET__BrZWdl$a__"